import { EventEmitter } from 'events';
import { TypedEmitter } from '../util';

export class PromisesSequence {
  readonly fns: (() => unknown)[] = [];

  readonly events = new EventEmitter() as TypedEmitter<{
    start: () => unknown;
    success: () => unknown;
    done: () => unknown;
  }>;

  readonly state = {
    running: false,
  };

  async enqueue<R>(fn: () => R) {
    const { fns, events, state } = this;
    fns.push(fn);

    if (state.running) {
      return new Promise<void>((resolve) => {
        events.once('success', resolve);
      });
    }

    events.emit('start');

    state.running = true;
    let next;
    try {
      while (fns.length) {
        next = fns.shift();
        await next?.();
      }
      events.emit('success');
      events.emit('done');
      state.running = false;
    } catch (e) {
      if (next) {
        fns.unshift(next);
      }
      events.emit('done');
      state.running = false;
      throw e;
    }
  }

  clear() {
    this.fns.splice(0);
  }
}
